import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMoreInput} from "../abstract-more-input";
import {FUIOptionsService} from "../../../framework/options.service";
import { PopParentHorizontalAlignment } from "../../../../pops/abstract-pop";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIHeaderMoreInputComponent),
            multi: true
        }
    ],
    selector: "fui-header-more-input",
    styleUrls: ["./header-more-input.component.scss"],
    templateUrl: "./header-more-input.component.html"
})
export class FUIHeaderMoreInputComponent extends FUIAbstractMoreInput {
    PopParentHorizontalAlignment = PopParentHorizontalAlignment;

    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, optionsService, changeDetectorRef);
    }
}
